// Logs Core Web Vitals to the browser console for performance baselining.
// Uses the already-installed web-vitals@2 API (getCLS/getFCP/getFID/getLCP/getTTFB).
//
//   LCP  — Largest Contentful Paint: when the main content is visible (perceived load)
//   FCP  — First Contentful Paint: first pixel painted
//   TTFB — Time To First Byte: network + backend latency to the HTML shell
//   CLS  — Cumulative Layout Shift (unitless)
//   FID  — First Input Delay: input responsiveness (ms)

function logMetric({ name, value }) {
  const isMs = name !== 'CLS';
  const shown = isMs ? `${Math.round(value)}ms` : value.toFixed(3);
  // eslint-disable-next-line no-console
  console.log(
    `%c[web-vitals] ${name.padEnd(4)} ${shown}`,
    'color:#7c3aed;font-weight:bold',
  );
}

export default function reportWebVitals() {
  import('web-vitals')
    .then(({ getCLS, getFCP, getFID, getLCP, getTTFB }) => {
      getTTFB(logMetric);
      getFCP(logMetric);
      getLCP(logMetric);
      getFID(logMetric);
      getCLS(logMetric);
    })
    .catch(() => {});
}
